import { defineMessages, IntlShape, MessageDescriptor } from "react-intl";
import { snakeCaseToCapitalizedWords } from "@app/utils";

// Keys mirror LIMS CommercialCancerType, the values SOS stores for oncology orders.
const labels: Record<string, MessageDescriptor> = defineMessages({
  COLORECTAL: {
    id: "cancerTypeLabel.COLORECTAL",
    defaultMessage: "Colorectal",
  },
  BREAST: { id: "cancerTypeLabel.BREAST", defaultMessage: "Breast" },
  BLADDER: { id: "cancerTypeLabel.BLADDER", defaultMessage: "Bladder" },
  LUNG: { id: "cancerTypeLabel.LUNG", defaultMessage: "Lung" },
  LYMPHOMA: { id: "cancerTypeLabel.LYMPHOMA", defaultMessage: "Lymphoma" },
  MELANOMA: { id: "cancerTypeLabel.MELANOMA", defaultMessage: "Melanoma" },
  ADRENAL: { id: "cancerTypeLabel.ADRENAL", defaultMessage: "Adrenal" },
  AMPULLARY: { id: "cancerTypeLabel.AMPULLARY", defaultMessage: "Ampullary" },
  ANAL: { id: "cancerTypeLabel.ANAL", defaultMessage: "Anal" },
  APPENDICEAL: {
    id: "cancerTypeLabel.APPENDICEAL",
    defaultMessage: "Appendiceal",
  },
  BILIARY_TRACT: {
    id: "cancerTypeLabel.BILIARY_TRACT",
    defaultMessage: "Biliary Tract",
  },
  BRAIN: { id: "cancerTypeLabel.BRAIN", defaultMessage: "Brain" },
  CARDIOVASCULAR: {
    id: "cancerTypeLabel.CARDIOVASCULAR",
    defaultMessage: "Cardiovascular",
  },
  CENTRAL_NERVOUS_SYSTEM: {
    id: "cancerTypeLabel.CENTRAL_NERVOUS_SYSTEM",
    defaultMessage: "Central Nervous System",
  },
  CERVIX: { id: "cancerTypeLabel.CERVIX", defaultMessage: "Cervix" },
  CUTANEOUS_BASAL_CELL_CARCINOMA: {
    id: "cancerTypeLabel.CUTANEOUS_BASAL_CELL_CARCINOMA",
    defaultMessage: "Cutaneous Basal Cell Carcinoma",
  },
  CUTANEOUS_SQUAMOUS_CELL_CARCINOMA: {
    id: "cancerTypeLabel.CUTANEOUS_SQUAMOUS_CELL_CARCINOMA",
    defaultMessage: "Cutaneous Squamous Cell Carcinoma",
  },
  ENDOMETRIAL: {
    id: "cancerTypeLabel.ENDOMETRIAL",
    defaultMessage: "Endometrial",
  },
  ESOPHAGEAL: {
    id: "cancerTypeLabel.ESOPHAGEAL",
    defaultMessage: "Esophageal",
  },
  FALLOPIAN_TUBE: {
    id: "cancerTypeLabel.FALLOPIAN_TUBE",
    defaultMessage: "Fallopian Tube",
  },
  GASTRIC: { id: "cancerTypeLabel.GASTRIC", defaultMessage: "Gastric" },
  GASTROESOPHAGEAL_JUNCTION: {
    id: "cancerTypeLabel.GASTROESOPHAGEAL_JUNCTION",
    defaultMessage: "Gastroesophageal Junction",
  },
  GASTROINTESTINAL_STROMAL_TUMOR: {
    id: "cancerTypeLabel.GASTROINTESTINAL_STROMAL_TUMOR",
    defaultMessage: "Gastrointestinal Stromal Tumor",
  },
  HEAD_AND_NECK: {
    id: "cancerTypeLabel.HEAD_AND_NECK",
    defaultMessage: "Head and Neck",
  },
  HEMATOLOGIC: {
    id: "cancerTypeLabel.HEMATOLOGIC",
    defaultMessage: "Hematologic",
  },
  HEPATOCELLULAR_CARCINOMA: {
    id: "cancerTypeLabel.HEPATOCELLULAR_CARCINOMA",
    defaultMessage: "Hepatocellular Carcinoma",
  },
  KIDNEY: { id: "cancerTypeLabel.KIDNEY", defaultMessage: "Kidney" },
  MELANOMA_MUCOSAL: {
    id: "cancerTypeLabel.MELANOMA_MUCOSAL",
    defaultMessage: "Melanoma: Mucosal",
  },
  MELANOMA_UVEAL: {
    id: "cancerTypeLabel.MELANOMA_UVEAL",
    defaultMessage: "Melanoma: Uveal",
  },
  MERKEL_CELL_CARCINOMA: {
    id: "cancerTypeLabel.MERKEL_CELL_CARCINOMA",
    defaultMessage: "Merkel Cell Carcinoma",
  },
  MESOTHELIOMA_PERITONEAL: {
    id: "cancerTypeLabel.MESOTHELIOMA_PERITONEAL",
    defaultMessage: "Mesothelioma: Peritoneal",
  },
  MESOTHELIOMA_PLEURAL: {
    id: "cancerTypeLabel.MESOTHELIOMA_PLEURAL",
    defaultMessage: "Mesothelioma: Pleural",
  },
  NEUROENDOCRINE: {
    id: "cancerTypeLabel.NEUROENDOCRINE",
    defaultMessage: "Neuroendocrine",
  },
  OVARIAN: { id: "cancerTypeLabel.OVARIAN", defaultMessage: "Ovarian" },
  PANCREATIC: {
    id: "cancerTypeLabel.PANCREATIC",
    defaultMessage: "Pancreatic",
  },
  PENILE: { id: "cancerTypeLabel.PENILE", defaultMessage: "Penile" },
  PRIMARY_PERITONEAL: {
    id: "cancerTypeLabel.PRIMARY_PERITONEAL",
    defaultMessage: "Primary Peritoneal",
  },
  PROSTATE: { id: "cancerTypeLabel.PROSTATE", defaultMessage: "Prostate" },
  SALIVARY_GLAND: {
    id: "cancerTypeLabel.SALIVARY_GLAND",
    defaultMessage: "Salivary Gland",
  },
  SARCOMA: { id: "cancerTypeLabel.SARCOMA", defaultMessage: "Sarcoma" },
  SMALL_BOWEL: {
    id: "cancerTypeLabel.SMALL_BOWEL",
    defaultMessage: "Small Bowel",
  },
  TESTICULAR: {
    id: "cancerTypeLabel.TESTICULAR",
    defaultMessage: "Testicular",
  },
  THYMIC: { id: "cancerTypeLabel.THYMIC", defaultMessage: "Thymic" },
  THYROID: { id: "cancerTypeLabel.THYROID", defaultMessage: "Thyroid" },
  TRACHEAL: { id: "cancerTypeLabel.TRACHEAL", defaultMessage: "Tracheal" },
  UNKNOWN_PRIMARY: {
    id: "cancerTypeLabel.UNKNOWN_PRIMARY",
    defaultMessage: "Unknown Primary",
  },
  UPPER_URINARY_TRACT: {
    id: "cancerTypeLabel.UPPER_URINARY_TRACT",
    defaultMessage: "Upper Urinary Tract",
  },
  URETHRAL: { id: "cancerTypeLabel.URETHRAL", defaultMessage: "Urethral" },
  UTERINE_SARCOMA: {
    id: "cancerTypeLabel.UTERINE_SARCOMA",
    defaultMessage: "Uterine Sarcoma",
  },
  VULVOVAGINAL: {
    id: "cancerTypeLabel.VULVOVAGINAL",
    defaultMessage: "Vulvovaginal",
  },
  WILMS_TUMOR: {
    id: "cancerTypeLabel.WILMS_TUMOR",
    defaultMessage: "Wilms Tumor",
  },
});

const HIDDEN_CANCER_TYPES = ["NOT_PROVIDED", "OTHER"];
const ENUM_NAME_PATTERN = /^[A-Z0-9_]+$/;

// Unmapped values pass through unless enum-shaped, so legacy labels like
// "... (VSC)" keep their casing.
export const formatCancerType = (
  intl: IntlShape,
  value?: string
): string | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  const key = trimmed.toUpperCase();
  if (HIDDEN_CANCER_TYPES.includes(key)) return undefined;
  if (labels[key]) return intl.formatMessage(labels[key]);
  return ENUM_NAME_PATTERN.test(trimmed)
    ? snakeCaseToCapitalizedWords(trimmed)
    : trimmed;
};
